<template>
    <p v-if="showTip">
        <a href="https://futu.feishu.cn/wiki/wikcn4Wgwnr3vuxNvLNWAPMeRjd" target="_blank">
            如需上报奖励中心需使用请先关联活动！！
        </a>
    </p>
</template>
<script>
let {
    store: { variable }
} = FEGORender;

const APIURL = '/api/act-task-status/report';
import request from '../assets/scripts/request';
export default {
    name: 'static-act-task-status',
    props: ['taskId', 'trigger', 'status', 'tpl'],
    data() {
        return {
            v: variable.data,
            loading: false
        };
    },
    mounted() {
        if (this.trigger === 'pageview') {
            console.log('reportWithPageView');
            this.reportWithPageView();
        }
    },
    computed: {
        isLogin() {
            return !!this.v.UID;
        },
        actSign() {
            return this.v.ACT_SIGN;
        },
        showTip() {
            return !this.actSign;
        }
    },
    methods: {
        async postData() {
            if (this.actSign && this.taskId && typeof this.status === 'number') {
                const commonApiRequest = request.bindCommonApi('act-task-status');
                const r = await commonApiRequest.post('report', {
                    act_sign: this.actSign,
                    task_id: this.taskId,
                    status: this.status
                });
            }
        },
        /**
         * 触发上报
         */
        async hands() {
            // 0.未登录
            if (!this.isLogin) {
                return;
            }
            this.loading = true;
            try {
                this.loading = false;
                await this.postData();
                // Toast.tips(this.successText);
            } catch (e) {
                this.loading = false;
                console.error('reportWithHans', e);
                // Toast.fail(this.failText);
            }
        },
        async reportWithPageView() {
            if (!this.isLogin) {
                return;
            }
            try {
                await this.postData();
            } catch (e) {
                console.error('reportWithPageView', e);
            }
        }
    }
};
</script>
<style lang="less" scoped></style>
